import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { PrimaryButton, SmallButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonFlateButton from "../Common/CommonFlatButton";
import { FLAT_SMALL_BUTTONS, FLAT_SMALL_BUTTONS_LIST } from "../../../../Data/Buttons/FlatStyle";

const FlatSmallButtons = () => {
  const [buttonTooltip, setButttooltip] = useState(false);
  const buttonToggle = () => setButttooltip(!buttonTooltip);
  return (
    <Card>
      <CommonCardHeader title={SmallButton} span={FLAT_SMALL_BUTTONS} />
      <CardBody className="btn-showcase">
        <Btn size="sm" color="primary" className="btn-square" id="Tooltip-15">{PrimaryButton}</Btn>
        <ToolTip target="Tooltip-15" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-square btn-primary btn-sm</ToolTip>
        {FLAT_SMALL_BUTTONS_LIST.map((data, index) => (
          <CommonFlateButton key={index} item={data} size="sm" />
        ))}
      </CardBody>
    </Card>
  );
};

export default FlatSmallButtons;
